/**
 * PAPERCRYPTO — FEATURE FLAGS
 * 
 * Toggle features ON/OFF without code deletion.
 * To re-enable a feature, flip its value to true.
 * 
 * ⚠️ KEEP IN SYNC WITH: mobile/src/config/features.js (Rule Q parity)
 */

export const FEATURES = {
  /**
   * 📱 PHONE_OTP_ENABLED
   * Controls visibility of phone OTP login/signup UI.
   * 
   * When false:
   *   • "Phone OTP" tab hidden in auth screen
   *   • All phone OTP code preserved (just not rendered)
   *   • CountryCodePicker import preserved
   *   • State variables preserved (unused but no errors)
   * 
   * When true:
   *   • Full phone OTP UX restored
   *   • Requires SMS provider configured in .env
   *     (MSG91 / Twilio / Vonage / Fast2SMS)
   * 
   * Default: false (launch without phone OTP, save SMS costs)
   * 
   * To enable in future:
   *   1. Configure SMS provider credentials in backend .env
   *   2. Set this to true
   *   3. Save file → app auto-refreshes (no rebuild)
   */
  PHONE_OTP_ENABLED: false,

  /**
   * 📧 EMAIL_OTP_ENABLED
   * Email verification OTP for registration.
   * Uses Resend (free tier 3,000/month).
   */
  EMAIL_OTP_ENABLED: true,

  /**
   * 🌐 GOOGLE_OAUTH_ENABLED
   * Google Sign-In via auth.signIn.
   */
  GOOGLE_OAUTH_ENABLED: true,

  /**
   * 🍎 APPLE_OAUTH_ENABLED  
   * Apple Sign-In (web — limited support).
   */
  APPLE_OAUTH_ENABLED: true,
};

export default FEATURES;
